import React from 'react';
import './TextblockVariantHint.css';

/**
 * "Variante für <Ort>" below the textblock dropdown of the mail screens: the chosen textblock has a
 * location variant for the event's location, and that text is the one in the editor.
 * variant: TextblockVariantDto ({ locationId, locationName, … }) or null (renders nothing).
 */
function TextblockVariantHint({ variant }) {
  if (!variant) return null;
  return (
    <p className="textblockVariantHintLine">
      <span className="material-symbols-rounded textblockVariantHintIcon" aria-hidden="true">location_on</span>
      Variante für {variant.locationName}
    </p>
  );
}

export default TextblockVariantHint;
